// Text input + textarea + select, all unified under one visual style so
// forms across pages stay consistent.
import type {
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";

const fieldStyle: React.CSSProperties = {
  display: "block",
  width: "100%",
  padding: "8px 12px",
  background: "var(--surface)",
  color: "var(--text-primary)",
  border: "1px solid var(--border)",
  borderRadius: "var(--radius-sm)",
  outline: "none",
};

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  const { style, ...rest } = props;
  return <input {...rest} style={{ ...fieldStyle, ...style }} />;
}

export function Textarea(
  props: TextareaHTMLAttributes<HTMLTextAreaElement>,
) {
  const { style, ...rest } = props;
  return (
    <textarea
      {...rest}
      style={{
        ...fieldStyle,
        fontFamily: "var(--font-sans)",
        resize: "vertical",
        minHeight: 80,
        ...style,
      }}
    />
  );
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  const { style, ...rest } = props;
  return <select {...rest} style={{ ...fieldStyle, ...style }} />;
}

export function Label({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <label
      style={{
        display: "block",
        fontSize: 13,
        fontWeight: 600,
        color: "var(--text-secondary)",
        marginBottom: 6,
        ...style,
      }}
    >
      {children}
    </label>
  );
}
